<template>
  <div>
    <div class="title mb-3">{{ $t('movementGuide.title') }}</div>
    <b-table :fields="fieldsToBeShown" :items="formattedRoundMap" sort-by="round" class="figbHeader">
      <template #cell(vs)="data">
        <span v-html="data.value"></span>
      </template>
    </b-table>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import individualContest from "../mixins/individualContest";

export default {
  name: 'MovementGuide',
  mixins: [individualContest],
  computed: {
    ...mapGetters({
      playerCurrentSessionMap: 'players/playerCurrentSessionMap',
      currentRound: 'tournament/currentRound',
      pairName: 'players/pairsList',
      sectors: 'tournament/sector'
    }),
    formattedRoundMap() {
      const that = this;
      return this.playerCurrentSessionMap.map(el => {
        const siglaGirone = that.sectors.Phases[el.phase].Series[el.serie].Sessions[el.session].Groups[el.sector].Sigla;
        return {
          position: siglaGirone + el.table + " " + ['N', 'E', 'S', 'W'][el.position],
          round: el.round,
          boards: el.Boards,
          vs: that.opponentName(el),
          _rowVariant: el.round === that.currentRound ? 'warning' : undefined
        }

      });
    },
    fieldsToBeShown() {
      return [
        {
          key: 'round',
          label: this.$t('movementGuide.round')
        },
        {
          key: 'position',
          label: this.$t('movementGuide.position'),
        }, {
          key: 'vs',
          label: this.$t('movementGuide.vs'),
          formatter: val => val.replace(" - ", "<br>")
        },
        {
          key: 'boards',
          label: this.$t('movementGuide.boards'),
          formatter: value => value.join(', ')
        }
      ];
    }
  },
  methods: {
    opponentName(el) {
      const onNsSide = el.position % 2 === 0;
      if (this.isIndividual) {
        const playerLabel = code => this.playersByCode[code]?.Name ?? code;
        const ns = [playerLabel(el.N), playerLabel(el.S)].join(" - ");
        const ew = [playerLabel(el.E), playerLabel(el.W)].join(" - ");
        return onNsSide ? ew : ns;
      }

      return onNsSide ? this.pairName[el.EwEventId].Name : this.pairName[el.NsEventId].Name;
    }
  }
};
</script>

<style scoped>

>>> .figbHeader thead {
  color: #1e3a5f !important;
  background-color: #eef2f7 !important;
}

.title {
  width: 100%;
  margin: 0 auto;
  text-align: center;
  font-size: 1.2rem;
  font-weight: 700;
  color: #1e3a5f;
  letter-spacing: -0.01em;
}
</style>
